<template>
  <div>
    <h3>Ownership Details</h3>
    <div
      class="iff-notification"
      v-if="!removeTid"
      style="display: fixed; width: 100%"
    >
      You must manually fill in your ownership information to continue.
    </div>
    <Input
      @enter="next"
      :inputField="inputs.ssn"
      inputName="Social Security Number (SSN)"
      placeholder="XXX-XX-XXXX"
      inputType="ssn"
      :icons="{ right: 'fa-lock' }"
    />
    <p style="" id="encryption_label">
      We use encryption to protect your personal information.
    </p>
    <AddressInput
      :inputField="inputs.address"
      inputName="Home Address"
      inputType="string"
      @selectedAddress="updateAddress"
    />
    <Input
      @enter="next"
      :inputField="inputs.city"
      inputName="City"
      inputType="string"
      ref="city"
      v-show="show_address_fields == true"
    />
    <div id="state_container" v-show="show_address_fields == true">
      <Input
        @enter="next"
        :inputField="inputs.state"
        inputName="State"
        inputType="state"
        ref="state"
        v-show="show_address_fields == true"
      />
      <Input
        @enter="next"
        :inputField="inputs.zip"
        inputName="Zip Code"
        inputType="zip"
        ref="zip"
        v-show="show_address_fields == true"
      />
    </div>
    <i
      v-show="selected_address == true"
      class="address_selected fas fa-check"
    ></i
    >&nbsp;
    <i
      v-show="selected_address == false"
      class="address_selected"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 11 14" fill="none">
        <path d="M5.69565 13C5.69565 13 10.3913 8.82609 10.3913 5.69565C10.3913 3.10231 8.28899 1 5.69565 1C3.10232 1 1 3.10231 1 5.69565C1 8.82609 5.69565 13 5.69565 13Z" stroke="#999999"/>
        <path d="M7.19585 5.5001C7.19585 6.32852 6.52427 7.0001 5.69585 7.0001C4.86742 7.0001 4.19584 6.32852 4.19584 5.5001C4.19584 4.67167 4.86742 4.0001 5.69585 4.0001C6.52427 4.0001 7.19585 4.67167 7.19585 5.5001Z" stroke="#999999"/>
      </svg>
    </i>&nbsp; <label class="label full_address">{{ full_address }}</label>&nbsp;
    <a class="toggle_address" href="javascript:void(0)" @click="toggleAddressFields" role="button">
      Or enter address manually
    </a>
    <DatePicker :inputField="inputs.dob" inputName="DOB" inputType="string" />
    <br/>
    <br/>
    <br/>
    <br/>
    <div class="buttons is-right">
      <!-- <a v-if="!validate" class="button is-link is-inverted padded-button next-button" @click="back">Back</a> -->
      <a class="button is-link padded-button next-button continue-button" @click="next"
        >Continue</a
      >
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import AddressInput from "@/components/shared/AddressInput";
import DatePicker from "@/components/shared/DatePicker";
import ApplyPage from "@/components/shared/ApplyPage";
function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

export default {
  name: "VerifyOwnership",
  components: {
    Input,
    AddressInput,
    DatePicker,
  },
  props: {
    removeTid: Boolean,
  },
  mixins: [ApplyPage],
  data() {
    return {
      obj: "pg",
      inputs: {
        ssn: Input.model(),
        address: AddressInput.model(),
        city: Input.model(),
        state: Input.model(),
        zip: Input.model(),
        dob: Input.model(),
      },
      company_name: "",
      show_address_fields: false,
      selected_address: false,
      full_address : ''
    };
  },
  created: function(){
  },
  mounted: function () {
    let company_name = getWithExpiry("company_name");
    this.company_name = company_name;
    let zip = getWithExpiry("zip");
    this.inputs.zip.value = zip;
  },
  methods: {
    updateAddress: function (data) {
      console.log(data);
      this.inputs.city.value = data.city;
      this.inputs.state.value = data.state;
      this.inputs.zip.value = data.zip;
      if (
        data.city &&
        data.city !== "" &&
        data.state &&
        data.state !== "" &&
        data.zip &&
        data.zip !== ""
      ) {
        console.log('changing..')
        // this.show_address_fields = false;
        this.selected_address = true;
        this.full_address =
          data.street_number +
          " " +
          data.street +
          ", " +
          data.city +
          ", " +
          data.state +
          ", " +
          data.zip;
      }
    },
    toggleAddressFields: function () {
      this.show_address_fields = !this.show_address_fields;
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#encryption_label{
  text-align: left; 
  font-size: 0.8rem;
  font-family: Roboto;
  margin-left: 10px;
  color: #666;
}
#state_container{
  display: inline-flex;
  width: 100%;
}
#state_container div{
  width: 50%;
  margin-right: 10px;
}

.iff-notification {
  animation-name: notify;
  animation-duration: 8s;
  width: 100%;
  position: fixed;
  top: -100px;
  opacity: 0;
  left: 0px;
  z-index: 3;
  background: #3273dc;
  text-align: center;
  color: white;
  /* padding: 5px; */
  padding: 5px 10px;
  font-size: 14px;
}

@keyframes notify {
  5% {
    top: -100px;
    opacity: 0;
  }
  12.5% {
    top: 0px;
    opacity: 1;
  }
  92.5% {
    top: 0px;
  }
  100% {
    top: -100px;
    opacity: 1;
  }
}
.eligibility_label {
  font-weight: 500;
}

/* start google address */
.full_address {
  color: gray;
  display: inline-block;
  margin-bottom: 10px;
}
.toggle_address {
  /* color: #666; */
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
}
@media (max-width: 80em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 18px;
    display: inline-block;
  }
}
@media (max-width: 47.999em) {
  .full_address {
    margin-bottom: 0px;
  }
  .toggle_address {
    margin-bottom: 18px;
    display: inline-block;
  }
}
.address_selected {
  color: green;
}
/* end google address */
</style>